const _auto = "auto"
const _square = "1 / 1"
const _video = "16 / 9"
const config = { "auto": _auto, "square": _square, "video": _video, "1/2": "1 / 2", "2/1": "2 / 1", "3/2": "3 / 2", "4/3": "4 / 3", "4/5": "4 / 5", "5/4": "5 / 4", "6/5": "6 / 5", "16/3": "16/3", "16/5": "16 / 5", "16/11": "16 / 11",  }
export { config as default, _auto, _square, _video }